import { render, staticRenderFns } from "./ztSliderItem.vue?vue&type=template&id=6ca59037&scoped=true&"
import script from "./ztSliderItem.vue?vue&type=script&lang=js&"
export * from "./ztSliderItem.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/styles/components/ztSlider.css?vue&type=style&index=0&id=6ca59037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca59037",
  null
  
)

export default component.exports